import React from 'react';
import Button from '@atlaskit/button';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { Section } from '@atlaskit/menu';
import { NavigationGroup, NavigationLink } from '@css-xp/graphtypes';
import { getAtlassianStartUrl } from '../utils/navigation-utils';
import { NavLinkItem } from './navigation-link-items';

export const NavGroupItem = ({ group }: { group: NavigationGroup }) => (
  <div className="navigation-group-item">
    <Section title={group?.name ?? undefined} hasSeparator>
      <Button
        onClick={() => {
          window.open(getAtlassianStartUrl(), '_blank');
        }}
        className="atlassian-start-button"
        iconAfter={<ShortcutIcon label="" size="small" />}
      >
        Atlassian Start
      </Button>
      {(group.links ?? []).map((item, index) => (
        <NavLinkItem link={item as NavigationLink} key={`link-${index}`} />
      ))}
    </Section>
  </div>
);
